module.exports = __webpack_public_path__ + "static/media/task.9fdf2f91.svg";